
import moment from "moment";
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { months } from "./DateLocale";

const DateHeaderSettings = ({
    date, years, changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled
}) => {

    const locale = 'uk'

  return (
    <div>
        {/* Кнопка назад */}
        <button onClick={e => {
            e.preventDefault()
            decreaseMonth()
        }} disabled={prevMonthButtonDisabled}>
            <KeyboardArrowLeftIcon />
        </button>

        {/* Отображение месяца */}
        <select
            value={ months[locale][moment(date).format('MM') - 1] }
            onChange={
                ({ target: { value } }) => 
                    changeMonth(months[locale].indexOf(value))
                }
        >
            {
                months[locale].map((month) => (
                    <option key={month} value={month}>
                        {month}
                    </option>
                ))
            }
        </select>

        {/* Отображение года */}

        <select
            value={moment(date).format('yyyy')}
            onChange={({ target: { value } }) => changeYear(value)}
        >
            {
                years.map((year) => (
                    <option key={year} value={year}>
                        {year}
                    </option>
                ))
            }
        </select>

        {/* Кнопка дальше */}
        <button onClick={e => {
            e.preventDefault()
            increaseMonth()
        }} disabled={nextMonthButtonDisabled}>
            {/* {">"} */}
            <ChevronRightIcon />
        </button>
    </div>  
  )
}

export default DateHeaderSettings